import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import EmptyStateButton from "../Buttons/EmptyStateButton";
import { Campaign, Event } from "@markit/common.types";
import { CampaignDetails } from "../../redux/slices/campaignSlice";
import StandardBorderedContainer from "../Containers/StandardBorderedContainer";
import { AutomationItemPreview } from "../DisplayItem/CampaignItem/AutomationItemPreview";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAccountState } from "../../redux/slices/accountSlice";
import { isProductWithCheckout, productItemLabel } from "@markit/common.utils";

type TextsPanelProps = {
  event: Event;
  campaign: Campaign | undefined;
  campaignDetail: CampaignDetails | undefined;
};

export const TextsPanel = (props: TextsPanelProps) => {
  const { event, campaign, campaignDetail } = props;
  const { accountData } = useSelector(getAccountState).account;

  const isHost = useMemo(
    () => accountData.uid === campaign?.createdBy,
    [campaign?.createdBy, accountData.uid]
  );

  const itemLabel = useMemo(
    () => productItemLabel(event.eventType),
    [event.eventType]
  );

  return (
    <div className="ColumnNormal">
      {campaign && campaignDetail ? (
        <StandardBorderedContainer
          containerStyles={{
            backgroundColor: Colors.WHITE,
            padding: 14,
            borderRadius: 14,
            flex: 1,
          }}
        >
          <AutomationItemPreview
            campaignItem={campaign}
            campaignDetail={campaignDetail}
            onEventDashboard
          />
        </StandardBorderedContainer>
      ) : null}
      {isProductWithCheckout(event.eventType, event.accessLevel) ? (
        <EmptyStateButton
          title={isHost ? "Send and Schedule Texts" : "Text Your Following"}
          description={
            isHost
              ? "Send and schedule automated texts to your audience."
              : `Only the creator of this ${itemLabel.entity} can manage text reminders. Text your following to promote this ${itemLabel.entity}.`
          }
          icon={
            <Icon
              icon={
                isHost ? "mdi:local-area-network" : "ion:chatbubble-ellipses"
              }
              height={55}
            />
          }
          iconBox={80}
          iconBackgroundColor={Colors.WHITE}
          containerStyles={{ paddingTop: 120 }}
        />
      ) : null}
    </div>
  );
};
